module.exports = __webpack_public_path__ + "public/media/digital-vector1.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/digital-vector1.png
// module id = ./images/services/digital-vector1.png
// module chunks = 0